import React, { Component } from 'react';
import Search from './Search';
import { Link, Route } from 'react-router-dom';

export default class Page extends Component {
	render() {
		return [
			<Link to="/" key="0">
				<h1><span>LiveStream.de</span> <small>Finde <strong>alle</strong> deutschen LIVE Streams</small></h1>
			</Link>,
			<Route path="/" component={Search} key="1" />
		];
	}
}


// WEBPACK FOOTER //
// ./src/Page.js